import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import {
  loadPodOptimizerFormState,
  persistPodOptimizerFormState,
} from 'watchtower-ui/redux/persistence/podOptimizerPersistence';
import optimizationReducer from 'watchtower-ui/redux/slices/optimization';
import podOptimizerReducer, { podOptimizerFormRestored } from 'watchtower-ui/redux/slices/podOptimizer';

export const store = configureStore({
  reducer: {
    optimization: optimizationReducer,
    podOptimizer: podOptimizerReducer,
  },
});

const persistedPodOptimizerFormState = loadPodOptimizerFormState();
if (persistedPodOptimizerFormState) {
  store.dispatch(podOptimizerFormRestored(persistedPodOptimizerFormState));
}

let previousPodOptimizerFormState = store.getState().podOptimizer;
store.subscribe(() => {
  const podOptimizerFormState = store.getState().podOptimizer;
  if (podOptimizerFormState === previousPodOptimizerFormState) {
    return;
  }

  previousPodOptimizerFormState = podOptimizerFormState;
  persistPodOptimizerFormState(podOptimizerFormState);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
